import { TariffsProduct } from 'src/components/TariffPlans/types';

const parseText = (str: string) => {
  return str.replace(/&nbsp;/g, '\u00A0');
};

export function getCardTitle(product: TariffsProduct) {
  switch (product) {
    case 'evolutionCloudServer':
      return parseText('Соберите свою виртуальную машину в&nbsp;калькуляторе');
    case 'evolutionKubernetes':
      return parseText('Соберите свой Kubernetes в&nbsp;калькуляторе');
    case 'evolutionStorageS3':
      return parseText(
        'Соберите свое Объектное хранилище S3 в&nbsp;калькуляторе',
      );
    case 'evolutionBareMetal':
      return parseText(
        'Выберите свою конфигурацию Bare&nbsp;Metal в&nbsp;калькуляторе',
      );
    case 'evolutionCloudServerGpu':
      return parseText(
        'Выберите свою виртуальную машину GPU в&nbsp;калькуляторе',
      );
    case 'evolutionPostgreSql':
      return parseText('Соберите свой кластер баз данных в&nbsp;калькуляторе');
    case 'evolutionMlInferenceInstanceTypeGpu':
    case 'evolutionMlInferenceModelSharedGpu':
      return parseText('Соберите свою конфигурацию для запуска инференса');
    default:
      return parseText('Соберите свою конфигурацию в&nbsp;калькуляторе');
  }
}
